const PublicRouteWrapper = ({ children }) => {
  return <>{children}</>;
};

export default PublicRouteWrapper;